export default __webpack_public_path__ + "static/media/BCM-.c954f490.svg";